var Promise = require('bluebird')
module.exports = require('./base')(Promise)